var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"white--text text-truncate hidden-sm-and-down",attrs:{"cols":"4"}},[_c('span',[_vm._v(_vm._s(_vm.currentTime))]),_c('span',{style:({
      borderLeft: '1px solid rgb(255 255 255)',
      margin: '0px 15px'
    })}),_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }